import React, { Fragment, Component } from "react";
import Shimmer from "react-shimmer-effect";

import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Button,
  Fieldset,
  Legend,
  Label,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";
import { FileInput, generateFormData } from "../../../../helpers/ui/FileInput";
import {
  AvForm,
  AvGroup,
  AvInput,
  AvField,
  AvCheckboxGroup,
  AvCheckbox,
} from "availity-reactstrap-validation";
import Select from "react-select";

import { Link, useHistory, Redirect } from "react-router-dom";
import apiResponse from "../../../../services/apiResponse";
import CreateBloc from "./Blocs/CreateBloc";
import { accessRole } from "../../../../helpers/access_role";
import CustomSelect from "../../GlobalComponents/CustomSelect";
import moment from "moment";

var reformatEmployee = function (employee) {
  return employee.map(function (region) {
    var newObj = {};
    newObj["label"] = region.employee_nip + " - " + region.employee_full_name;
    newObj["value"] = region.employee_uuid;
    newObj["model"] = region;
    return newObj;
  });
};

var reformatRank = function (ranks) {
  return ranks.map(function (rank) {
    var newObj = {};
    newObj["label"] = rank.rank_name;
    newObj["value"] = rank.rank_uuid;
    newObj["model"] = rank;
    return newObj;
  });
};

var reformatType = function (regions) {
  return regions.map(function (region) {
    var newObj = {};
    newObj["label"] = region.retired_type_name;
    newObj["value"] = region.retired_type_uuid;
    return newObj;
  });
};

class IndexView extends Component {
  createBloc = new CreateBloc();

  constructor(props) {
    super(props);
    this.state = {
      dataForm: {
        promotion_employee_uuid: props.pegawai_uuid,
        promotion_period_promotion_uuid: props.uuid,
      },
      OpsiApproval: [
        { label: "Disetujui", value: "1" },
        { label: "Ditolak", value: "2" },
      ],
      employeeItems: [],
      rankItems: [],
      employeeSelected: props.pegawai_uuid,
      pangkatSelected: "",
      typeItems: [],
      typeSelected: "",
      loadingDetail: false,
    };
  }

  submitData = async () => {
    const formData = generateFormData(this.state.dataForm, "file_sk"); // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto']
    await this.createBloc.fetchCreate(formData);
  };

  handlerOnSubmit = (e, values) => {
    e.preventDefault();
    this.setState({
      dataForm: {
        promotion_employee_uuid: this.props.pegawai_uuid,
        promotion_period_promotion_uuid: this.props.uuid,
        ...values,
      },
      confirm: true,
    });
    console.log(this.state.dataForm);
  };

  onChangePangkat = (rank) => {
    var model = rank.model;
    console.log(rank);
    this.setState({
      pangkatSelected: rank.value,
      dataForm: {
        //promotion_rank_group_room: model.rank_group_room,
        promotion_rank_uuid: rank.value,
      },
    });
  };
  onChangeEmployee = (employee) => {
    var model = employee.model;

    this.setState({
      employeeSelected: employee.value,
      employee_rank_group: model.employee_current_rank_group,
      promotion_rank_group_room_old: model.employee_current_rank_group_room,
      pangkatSelected: "",
      promotion_rank_uuid: "",
      promotion_rank_group_room: "",
      dataForm: {
        promotion_rank_uuid_old: model.employee_current_rank_uuid,
        promotion_rank_group_room_old: model.employee_current_rank_group_room,
        promotion_rank_tmt_old: model.employee_current_tmt_rank,
        promotion_employee_uuid: model.promotion_employee_uuid,
        promotion_year_period_old: model.rank_history_year_period,
        promotion_month_period_old: model.rank_history_month_period,
        promotion_rank_group_room: "",
        promotion_rank_uuid_old: model.employee_current_rank_uuid,
        promotion_position_name_old: model.employee_current_position_name,
        promotion_rank_name_old: model.employee_current_rank_name,
        promotion_rank_tmt_old_temp: moment(
          model.employee_current_tmt_rank
        ).format("DD-MM-YYYY"),
      },
    });
    console.log(this.state);

    this.createBloc.rankChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              rankItems: reformatRank(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchRank({
      employee_rank_group: model.employee_current_rank_group,
      employee_rank_room: model.employee_current_rank_room,
    });
  };

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        this.submitData();
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  componentDidMount() {
    this.createBloc.createChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          this.setState({
            loading: false,
            success: true,
          });
          break;
        case apiResponse.ERROR:
          this.setState({
            loading: false,
            failed: true,
          });
          break;
        default:
          break;
      }
    });

    this.createBloc.employeeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              employeeItems: reformatEmployee(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });

    this.createBloc.typeChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              typeItems: reformatType(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.INITIAL:
          this.setState({
            loadingDetail: true,
          });
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.result;
            this.setState({
              detail: response,
              pangkatSelected: response.promotion_rank_uuid,
              rankItems: [
                {
                  label: response.promotion_rank_name,
                  value: response.promotion_rank_uuid,
                },
              ],
            });

            this.createBloc.fetchRank({
              employee_rank_group: response.employee_current_rank_group,
              employee_rank_room: response.employee_current_rank_room,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
    this.createBloc.fetchDetail({
      uuid: this.props.uuid,
      promotion_employee_uuid: this.props.pegawai_uuid,
    });
    this.createBloc.fetchEmployee();

    this.createBloc.rankChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response;
            this.setState({
              rankItems: reformatRank(response.result),
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
  }

  render() {
    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card className="">
                <CardBody>
                  <CardTitle>
                    Verifikasi Data Pegawai Kenaikan Pangkat
                  </CardTitle>
                  <CardSubtitle className="mb-3">
                    Setiap isian yang bertanda (
                    <span className="text-danger">*</span>) adalah wajib diisi.
                  </CardSubtitle>
                  <hr />
                  <AvForm
                    className="needs-validation"
                    onValidSubmit={(e, values) =>
                      this.handlerOnSubmit(e, values)
                    }
                  >
                    <Row className="mb-3">
                      <label className="col-md-3">NIP</label>
                      <Col md="9">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.employee_nip !== ""
                              ? this.state.detail.employee_nip
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "50%", height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3">Nama</label>
                      <Col md="9">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.employee_full_name !== ""
                              ? this.state.detail.employee_full_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "50%", height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label className="col-md-3">Jenis Kenaikan Pangkat</label>
                      <Col md="9">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.rank_type_name !== ""
                              ? this.state.detail.rank_type_name
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "50%", height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      ></label>
                      <Col md="4">
                        <label className="col-form-label">PANGKAT LAMA</label>
                      </Col>
                      <Col md="4">
                        <label className="col-form-label text-center">
                          PANGKAT USULAN
                        </label>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Pangkat <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.promotion_rank_name_old !== ""
                              ? this.state.detail.promotion_rank_name_old
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "50%", height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {/* <Select
                          value={this.state.rankItems.filter(
                            (option) =>
                              option.value === this.state.pangkatSelected
                          )}
                          
                          required="required"
                          options={this.state.rankItems}
                          classNamePrefix=""
                          placeholder="Pilih Pangkat"
                        /> */}
                        <CustomSelect
                            name="credit_number_type"
                            errorMessage="Pilih Pangkat"
                            options={this.state.rankItems}
                            placeholder="Pilih Pangkat"
                            defaultValue={this.state.pangkatSelected}
                            onChange={this.onChangePangkat}
                            isAvForm={false}
                        />
                        <AvField
                          name="promotion_rank_uuid"
                          type="hidden"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          id="promotion_rank_uuid"
                          value={this.state.pangkatSelected}
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        TMT Pangkat <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.promotion_rank_tmt_old !== ""
                              ? moment(
                                  this.state.detail.promotion_rank_tmt_old
                                ).format("DD-MM-YYYY")
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "50%", height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.promotion_rank_tmt_date !==
                            "" ? (
                              <AvField
                                name="promotion_tmt_date"
                                placeholder="TMT Pangkat"
                                type="date"
                                errorMessage="Masukan TMT Pangkat"
                                className="form-control"
                                rows="8"
                                id="promotion_tmt_date"
                                validate={{ required: { value: true } }}
                                value={moment(
                                  this.state.detail.promotion_rank_tmt_date
                                ).format("YYYY-MM-DD")}
                              />
                            ) : (
                              "-"
                            )}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "50%", height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Gol/Ruang <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.promotion_rank_group_room_old !==
                            ""
                              ? this.state.detail.promotion_rank_group_room_old
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "50%", height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.promotion_rank_group_room !==
                            "" ? (
                              <AvField
                                name="promotion_rank_group_room"
                                placeholder="Gol/Ruang"
                                type="text"
                                errorMessage="Masukan Gol/Ruang"
                                className="form-control"
                                rows="8"
                                id="promotion_rank_group_room"
                                value={
                                  this.state.detail.promotion_rank_group_room
                                }
                              />
                            ) : (
                              "-"
                            )}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "50%", height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Masa Kerja <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.promotion_year_period_old !==
                              "" &&
                            this.state.detail.promotion_year_period_old !== null
                              ? this.state.detail.promotion_year_period_old +
                                " Tahun"
                              : "0 Tahun"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "50%", height: 15 }}></div>
                          </Shimmer>
                        )}
                        {this.state.detail ? (
                          <>
                            {this.state.detail.promotion_month_period_old !==
                            null
                              ? " " +
                                this.state.detail.promotion_month_period_old +
                                " Bulan"
                              : " 0 Bulan"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "0%", height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="1">
                        <AvField
                          name="promotion_year_period"
                          placeholder="Tahun"
                          type="text"
                          errorMessage="Masukan Tahun"
                          className="form-control"
                          rows="8"
                          id="promotion_year_period"
                          value={this.state.detail?.promotion_year_period}
                        />
                      </Col>
                      <Col md="1" className="text-center">
                        <label className="col-form-label">Tahun</label>
                      </Col>
                      <Col md="1">
                        <AvField
                          name="promotion_month_period"
                          placeholder="Bulan"
                          type="text"
                          errorMessage="Masukan Bulan"
                          className="form-control"
                          rows="8"
                          id="promotion_month_period"
                          value={this.state.detail?.promotion_month_period}
                        />
                      </Col>
                      <Col md="1" className="text-center">
                        <label className="col-form-label">Bulan</label>
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Jabatan <span className="text-danger">*</span>
                      </label>
                      <Col md="4">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.promotion_position_name_old !==
                            ""
                              ? this.state.detail.promotion_position_name_old
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "50%", height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                      <Col md="4">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.promotion_position_name !==
                            "" ? (
                              <AvField
                                name="promotion_position_name"
                                placeholder="Jabatan"
                                type="text"
                                errorMessage="Masukan Jabatan"
                                className="form-control"
                                rows="8"
                                id="promotion_position_name"
                                value={
                                  this.state.detail.promotion_position_name
                                }
                              />
                            ) : (
                              "-"
                            )}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: "50%", height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <hr />

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Nomor Persetujuan Teknis BKN{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <AvField
                          name="promotion_pertek_bkn_number"
                          id="promotion_pertek_bkn_number"
                          placeholder="Nomor Persetujuan Teknis BKN"
                          type="text"
                          errorMessage="Masukan Nomor Persetujuan Teknis BKN"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.detail?.promotion_pertek_bkn_number}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal Persetujuan Teknis BKN{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Col md="2">
                        <AvField
                          name="promotion_pertek_bkn_date"
                          id="promotion_pertek_bkn_date"
                          placeholder="Tanggal Persetujuan Teknis BKN"
                          type="date"
                          errorMessage="Masukan Tanggal Persetujuan Teknis BKN"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.detail?.promotion_pertek_bkn_date}
                        />
                      </Col>
                    </Row>

                    <hr />

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Nomor SK <span className="text-danger">*</span>
                      </label>
                      <Col md="3">
                        <AvField
                          name="promotion_decree_number"
                          id="promotion_decree_number"
                          placeholder="Nomor SK"
                          type="text"
                          errorMessage="Masukan Nomor SK"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.detail?.promotion_decree_number}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Tanggal SK <span className="text-danger">*</span>
                      </label>
                      <Col md="2">
                        <AvField
                          name="promotion_decree_date"
                          id="promotion_decree_date"
                          placeholder="Tanggal SK"
                          type="date"
                          errorMessage="Masukan Tanggal SK"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.detail?.promotion_decree_date}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        TMT SK <span className="text-danger">*</span>
                      </label>
                      <Col md="2">
                        <AvField
                          name="promotion_tmt_date"
                          id="promotion_tmt_date"
                          placeholder="TMT SK"
                          type="date"
                          errorMessage="Masukan TMT SK"
                          className="form-control"
                          validate={{ required: { value: true } }}
                          value={this.state.detail?.promotion_tmt_date}
                        />
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <Label className="col-md-3 col-form-label">
                        Upload File SK
                      </Label>
                      <Col md="6">
                        <FileInput name="file_sk" col="2" />
                      </Col>
                      <Col md="3">
                        {this.state.loadingDetail ? (
                          <Shimmer>
                            <div style={{ width: "30%", height: 15 }}></div>
                          </Shimmer>
                        ) : this.state.detail &&
                          this.state.detail.document_sk_new ? (
                          <a
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-sm btn-primary"
                            href={
                              this.state.detail.document_sk_new.documents_path
                            }
                          >
                            <i className="uil-file-download"></i> Download File
                          </a>
                        ) : null}
                      </Col>
                    </Row>

                    <Row className="mb-3">
                      <label
                        htmlFor="no_sk"
                        className="col-md-3 col-form-label"
                      >
                        Status Approval <span className="text-danger">*</span>
                      </label>

                      <Col md="3">
                        <CustomSelect
                          name="promotion_status"
                          required="required"
                          errorMessage="Pilih Status Approval"
                          options={this.state.OpsiApproval}
                          placeholder="Pilih Status Approval"
                        />
                      </Col>
                    </Row>
                    <Row className="mb-3">
                      <Col md="3"></Col>
                      <Col md="9">
                        <Link to={`?pegawai&uuid=` + this.props.uuid}>
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>{" "}
                        <Button color="success" type="submit">
                          <i className="uil-arrow-up-right"></i> Simpan
                        </Button>
                      </Col>
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        <ConfirmAlert
          confirmTitle="Konfirmasi!"
          confirmInfo="Apakah anda yakin akan menyimpan data ini?"
          loadingTitle="Mengirim data..."
          loadingInfo="Tunggu beberapa saat"
          successTitle="Berhasil!"
          successInfo="Data berhasil disimpan"
          failedTitle="Gagal!"
          failedInfo="Data gagal disimpan"
          showConfirm={this.state.confirm}
          showLoading={this.state.loading}
          showSuccess={this.state.success}
          showFailed={this.state.failed}
          response={this.confirmResponse}
        />
        {this.state.redirect ? (
          <Redirect
            to={
              `/kepegawaian/kenaikan_pangkat.html?pegawai&uuid=` +
              this.props.uuid
            }
          />
        ) : null}
      </Fragment>
    );
  }
}

export default IndexView;
